import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from 'Redux/store';
import { createRoot } from "react-dom/client";

createRoot(document.getElementById('root')).render(
    <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
);
